// User Service - Handles Firebase + PostgreSQL integration
import { API_BASE_URL } from '../config/apiEndpoints';

export class UserService {
  // Create user profile in PostgreSQL after Firebase registration
  static async createUserProfile(firebaseUser, additionalData = {}) {
    try {
      const userProfile = {
        firebase_uid: firebaseUser.uid,
        email: firebaseUser.email,
        display_name: firebaseUser.displayName || additionalData.displayName,
        phone: additionalData.phone || null,
        profile_picture_url: firebaseUser.photoURL || null,
        preferences: {
          notifications: true,
          marketing: additionalData.marketingConsent || false,
          ...additionalData.preferences
        }
      };

      const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await firebaseUser.getIdToken()}`
        },
        body: JSON.stringify(userProfile)
      });

      if (!response.ok) {
        throw new Error('Failed to create user profile');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Get user profile from PostgreSQL
  static async getUserProfile(firebaseUser) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${firebaseUser.uid}`, {
        headers: {
          'Authorization': `Bearer ${await firebaseUser.getIdToken()}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch user profile');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Update user profile in PostgreSQL
  static async updateUserProfile(firebaseUser, updates) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${firebaseUser.uid}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${await firebaseUser.getIdToken()}`
        },
        body: JSON.stringify(updates)
      });

      if (!response.ok) {
        throw new Error('Failed to update user profile');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Delete user profile from PostgreSQL
  static async deleteUserProfile(firebaseUser) {
    try {
      const response = await fetch(`${API_BASE_URL}/users/${firebaseUser.uid}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${await firebaseUser.getIdToken()}`
        }
      });

      if (!response.ok) {
        throw new Error('Failed to delete user profile');
      }

      return true;
    } catch (error) {
      throw error;
    }
  }
}
